import Vue from "vue";
import VueBar from "vuebar";

Vue.use(VueBar);